import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { OeAppService } from './oe-app.service';
import { ClassUpsellSignupDto } from './types/ClassUpsellSignupDto';

@Injectable()
export class LiveClassPcPromoService {
  constructor(
    private http: HttpClient,
    private oeAppService: OeAppService
  ) { }

  public isPcUpsellEligible() {
    return this.oeAppService.getPersonData().pcUpsellEligible;
  }

  public saveToCampaign() {
    const payload = {
      classType: ClassUpsellSignupDto.PRIVATE,
      contactId: this.oeAppService.getPersonData().contactId
    }
    this.http.post(`${this.oeAppService.accountApiGatewayHost()}/v1/class-upsell/sign-ups`, payload).subscribe();
  }
}



// WEBPACK FOOTER //
// ./ts/app/shared/live-class-pc-promo.service.ts